import "./NewsRegulations.module.css";
import HeaderNavigazione from "@/reusable_sections/Header";
import AggiornamentiEApprofondimenti from "./sections/AggiornamentiEApprofondimenti";
import RecentArticles from "./sections/RecentArticles";
import Footer from "@/reusable_sections/Footer";
export default function NewsRegulationsPage() {
  return <div>
      <HeaderNavigazione />
      <AggiornamentiEApprofondimenti />
      <RecentArticles />
      <Footer />
    </div>;
}